require('./bootstrap');

// Components
require('./components/utilities');
require('./components/disclaimer');
require('./components/colorbox');
require('./components/post');
require('./components/stagger-boxes');
require('./components/typeit');

// Blocks
require('./blocks/accordion');
require('./blocks/stats');
require('./blocks/tabs');

import { typeit } from "./components/typeit";

jQuery(document).ready(function ($) {
    typeit();
});
